import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  FormGroup,
  TextField,
  Autocomplete,
  Chip,
} from "@mui/material";
import collegeTeams from "../components/Utils/collegeTeams";

const PortalFilterPop = ({
  open,
  filterType,
  onClose,
  onSave,
  selectedValue,
  options,
  title,
}) => {
  const [selected, setSelected] = useState(selectedValue);
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);

  useEffect(() => {
    if (filterType === "position") {
      // Convert comma-separated string to array for positions
      setSelectedPositions(
        selectedValue === "all" ? [] : selectedValue.split(",")
      );
    } else if (filterType === "teams") {
      // Convert comma-separated string to array for teams
      setSelectedTeams(selectedValue === "all" ? [] : selectedValue.split(","));
    } else {
      setSelected(selectedValue);
    }
  }, [selectedValue, open, filterType]);

  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  const handlePositionChange = (event) => {
    const position = event.target.value;
    const isChecked = event.target.checked;

    setSelectedPositions((prev) => {
      if (isChecked) {
        return [...prev, position];
      } else {
        return prev.filter((pos) => pos !== position);
      }
    });
  };

  const handleTeamsChange = (event, newValue) => {
    setSelectedTeams(newValue);
  };

  const handleSave = () => {
    if (filterType === "position") {
      const positionValue =
        selectedPositions.length > 0 ? selectedPositions.join(",") : "all";
      onSave(filterType, positionValue);
    } else if (filterType === "teams") {
      const teamsValue =
        selectedTeams.length > 0 ? selectedTeams.join(",") : "all";
      onSave(filterType, teamsValue);
    } else {
      onSave(filterType, selected);
    }
    onClose();
  };

  const renderFilterContent = () => {
    if (filterType === "position") {
      return (
        <FormGroup className="portal-filter-pop-options">
          {options.map(
            (option) =>
              option.value !== "all" && (
                <FormControlLabel
                  key={option.value}
                  control={
                    <Checkbox
                      checked={selectedPositions.includes(option.value)}
                      onChange={handlePositionChange}
                      value={option.value}
                      style={{ color: "white" }}
                    />
                  }
                  label={option.label}
                />
              )
          )}
        </FormGroup>
      );
    } else if (filterType === "teams") {
      return (
        <Autocomplete
          multiple
          id="team-filter-autocomplete"
          options={collegeTeams}
          value={selectedTeams}
          onChange={handleTeamsChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Search for teams"
              placeholder="Type to search"
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option}
                {...getTagProps({ index })}
                key={option}
                color="primary"
              />
            ))
          }
          className="portal-filter-team-search"
          sx={{
            "& .MuiOutlinedInput-root": {
              color: "white",
            },
            "& .MuiInputLabel-root": {
              color: "#a0aec0",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#4a5568",
            },
          }}
        />
      );
    } else {
      return (
        <RadioGroup
          value={selected}
          onChange={handleChange}
          className="portal-filter-pop-options"
        >
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value.toString()}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      );
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="portal-filter-pop"
      PaperProps={{
        className: "portal-filter-pop-paper",
      }}
      aria-labelledby="portal-filter-dialog-title"
    >
      <DialogTitle
        className="portal-filter-pop-title"
        id="portal-filter-dialog-title"
      >
        {title || `Filter by ${filterType}`}
      </DialogTitle>
      <DialogContent>{renderFilterContent()}</DialogContent>
      <DialogActions>
        <Button sx={{ color: "#fff" }} onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PortalFilterPop;
